import { render } from "./distracted_time_card.svg?vue&type=template&id=6a85a77b"
const script = {}
script.render = render

export default script